/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleListUpdate
 */
export interface VehicleListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleStatus?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleSerialNumber?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehiclePhoneImei?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleDeviceSerialNumber?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleManufacturer?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleModel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleEngineType?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleManufactureYear?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleShockProfile?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehiclePreOpsChecklist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleChecklistOverride?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleIdleAutoLogoutAfter?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleLastSynchronizedAt?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehiclePurchaseDateOrContractTermStart?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleContractTermEnd?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleContractDaysRemaining?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehiclePurchaseCost?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleMonthlyCost?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleInitialOperatingHours?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleCurrentOperatingHours?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleLastMaintenanceOperatingHours?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleLastMaintenanceDate?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleNextMaintenanceHours?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleMaintenanceInterval?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleMaintenanceNotificationAt?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleMaintenanceLockdown?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleHoursUntilNextMaintenance?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleTypeLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    departmentLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    vehicleGroupLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListUpdate
     */
    userFullName?: boolean | null;
}

/**
 * Check if a given object implements the VehicleListUpdate interface.
 */
export function instanceOfVehicleListUpdate(value: object): value is VehicleListUpdate {
    return true;
}

export function VehicleListUpdateFromJSON(json: any): VehicleListUpdate {
    return VehicleListUpdateFromJSONTyped(json, false);
}

export function VehicleListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleStatus': json['vehicleStatus'] == null ? undefined : json['vehicleStatus'],
        'vehicleSerialNumber': json['vehicleSerialNumber'] == null ? undefined : json['vehicleSerialNumber'],
        'vehiclePhoneImei': json['vehiclePhoneImei'] == null ? undefined : json['vehiclePhoneImei'],
        'vehicleDeviceSerialNumber': json['vehicleDeviceSerialNumber'] == null ? undefined : json['vehicleDeviceSerialNumber'],
        'vehicleManufacturer': json['vehicleManufacturer'] == null ? undefined : json['vehicleManufacturer'],
        'vehicleModel': json['vehicleModel'] == null ? undefined : json['vehicleModel'],
        'vehicleEngineType': json['vehicleEngineType'] == null ? undefined : json['vehicleEngineType'],
        'vehicleManufactureYear': json['vehicleManufactureYear'] == null ? undefined : json['vehicleManufactureYear'],
        'vehicleShockProfile': json['vehicleShockProfile'] == null ? undefined : json['vehicleShockProfile'],
        'vehiclePreOpsChecklist': json['vehiclePreOpsChecklist'] == null ? undefined : json['vehiclePreOpsChecklist'],
        'vehicleChecklistOverride': json['vehicleChecklistOverride'] == null ? undefined : json['vehicleChecklistOverride'],
        'vehicleIdleAutoLogoutAfter': json['vehicleIdleAutoLogoutAfter'] == null ? undefined : json['vehicleIdleAutoLogoutAfter'],
        'vehicleLastSynchronizedAt': json['vehicleLastSynchronizedAt'] == null ? undefined : json['vehicleLastSynchronizedAt'],
        'vehiclePurchaseDateOrContractTermStart': json['vehiclePurchaseDateOrContractTermStart'] == null ? undefined : json['vehiclePurchaseDateOrContractTermStart'],
        'vehicleContractTermEnd': json['vehicleContractTermEnd'] == null ? undefined : json['vehicleContractTermEnd'],
        'vehicleContractDaysRemaining': json['vehicleContractDaysRemaining'] == null ? undefined : json['vehicleContractDaysRemaining'],
        'vehiclePurchaseCost': json['vehiclePurchaseCost'] == null ? undefined : json['vehiclePurchaseCost'],
        'vehicleMonthlyCost': json['vehicleMonthlyCost'] == null ? undefined : json['vehicleMonthlyCost'],
        'vehicleInitialOperatingHours': json['vehicleInitialOperatingHours'] == null ? undefined : json['vehicleInitialOperatingHours'],
        'vehicleCurrentOperatingHours': json['vehicleCurrentOperatingHours'] == null ? undefined : json['vehicleCurrentOperatingHours'],
        'vehicleLastMaintenanceOperatingHours': json['vehicleLastMaintenanceOperatingHours'] == null ? undefined : json['vehicleLastMaintenanceOperatingHours'],
        'vehicleLastMaintenanceDate': json['vehicleLastMaintenanceDate'] == null ? undefined : json['vehicleLastMaintenanceDate'],
        'vehicleNextMaintenanceHours': json['vehicleNextMaintenanceHours'] == null ? undefined : json['vehicleNextMaintenanceHours'],
        'vehicleMaintenanceInterval': json['vehicleMaintenanceInterval'] == null ? undefined : json['vehicleMaintenanceInterval'],
        'vehicleMaintenanceNotificationAt': json['vehicleMaintenanceNotificationAt'] == null ? undefined : json['vehicleMaintenanceNotificationAt'],
        'vehicleMaintenanceLockdown': json['vehicleMaintenanceLockdown'] == null ? undefined : json['vehicleMaintenanceLockdown'],
        'vehicleHoursUntilNextMaintenance': json['vehicleHoursUntilNextMaintenance'] == null ? undefined : json['vehicleHoursUntilNextMaintenance'],
        'vehicleTypeLabel': json['vehicleTypeLabel'] == null ? undefined : json['vehicleTypeLabel'],
        'departmentLabel': json['departmentLabel'] == null ? undefined : json['departmentLabel'],
        'vehicleGroupLabel': json['vehicleGroupLabel'] == null ? undefined : json['vehicleGroupLabel'],
        'userFullName': json['userFullName'] == null ? undefined : json['userFullName'],
    };
}

export function VehicleListUpdateToJSON(json: any): VehicleListUpdate {
    return VehicleListUpdateToJSONTyped(json, false);
}

export function VehicleListUpdateToJSONTyped(value?: VehicleListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleStatus': value['vehicleStatus'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'vehiclePhoneImei': value['vehiclePhoneImei'],
        'vehicleDeviceSerialNumber': value['vehicleDeviceSerialNumber'],
        'vehicleManufacturer': value['vehicleManufacturer'],
        'vehicleModel': value['vehicleModel'],
        'vehicleEngineType': value['vehicleEngineType'],
        'vehicleManufactureYear': value['vehicleManufactureYear'],
        'vehicleShockProfile': value['vehicleShockProfile'],
        'vehiclePreOpsChecklist': value['vehiclePreOpsChecklist'],
        'vehicleChecklistOverride': value['vehicleChecklistOverride'],
        'vehicleIdleAutoLogoutAfter': value['vehicleIdleAutoLogoutAfter'],
        'vehicleLastSynchronizedAt': value['vehicleLastSynchronizedAt'],
        'vehiclePurchaseDateOrContractTermStart': value['vehiclePurchaseDateOrContractTermStart'],
        'vehicleContractTermEnd': value['vehicleContractTermEnd'],
        'vehicleContractDaysRemaining': value['vehicleContractDaysRemaining'],
        'vehiclePurchaseCost': value['vehiclePurchaseCost'],
        'vehicleMonthlyCost': value['vehicleMonthlyCost'],
        'vehicleInitialOperatingHours': value['vehicleInitialOperatingHours'],
        'vehicleCurrentOperatingHours': value['vehicleCurrentOperatingHours'],
        'vehicleLastMaintenanceOperatingHours': value['vehicleLastMaintenanceOperatingHours'],
        'vehicleLastMaintenanceDate': value['vehicleLastMaintenanceDate'],
        'vehicleNextMaintenanceHours': value['vehicleNextMaintenanceHours'],
        'vehicleMaintenanceInterval': value['vehicleMaintenanceInterval'],
        'vehicleMaintenanceNotificationAt': value['vehicleMaintenanceNotificationAt'],
        'vehicleMaintenanceLockdown': value['vehicleMaintenanceLockdown'],
        'vehicleHoursUntilNextMaintenance': value['vehicleHoursUntilNextMaintenance'],
        'vehicleTypeLabel': value['vehicleTypeLabel'],
        'departmentLabel': value['departmentLabel'],
        'vehicleGroupLabel': value['vehicleGroupLabel'],
        'userFullName': value['userFullName'],
    };
}

